import React, { PureComponent, Fragment } from "react";
import { PropTypes } from "prop-types";
import { Icon } from "semantic-ui-react";

import { getIconByType } from "./ResourceIconMap.js";

import LinkWithReset from "../../utils/LinkWithReset.jsx";

class ResourceIcon extends PureComponent {
  static propTypes = {
    size: PropTypes.string,
    data: PropTypes.object.isRequired,
    disabled: PropTypes.bool
  };

  renderIcon = () => {
    const { data, size } = this.props;

    return (
      <Fragment>
        <Icon className={getIconByType(data["@type"])} size={size} />
        {` ${data.name}`}
      </Fragment>
    );
  };

  render() {
    const { data, disabled } = this.props;

    if (data["@id"] && !disabled) {
      return (
        <LinkWithReset
          to={`/resources${data["@id"]}`}
          className="resource-icon"
        >
          {this.renderIcon()}
        </LinkWithReset>
      );
    }

    return this.renderIcon();
  }
}

export default ResourceIcon;
